import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import LoginPage from "../LoginPage/LoginPage";
import Footer from "../../components/Common/Footer/Footer";
import ProtectedRoute from "../../hoc/ProtectedRoute";
import AdminPage from "../AdminPage/AdminPage";
import UserManagement from "../AdminPage/UserManagement/UserManagement";
import DashboardPage from "../DashboardPage/DashboardPage";
import DistributePage from "../DistributePage/DistributePage";
import EventsPage from "../EventsPage/EventsPage";
import MainPage from "../MainPage/MainPage";
import ContentBulkUpload from "../ManagePage/ContentBulkUpload/ContentBulkUpload";
import CreateShotclasses from "../ManagePage/CreateShotclasses/CreateShotclasses";
import CreateTrainingType from "../ManagePage/CreateTrainingType/CreateTrainingType";
import ManagePage from "../ManagePage/ManagePage";
import ManageTranscription from "../ManagePage/ManageTranscription/ManageTranscription";
import MyDrafts from "../ManagePage/MyDrafts/MyDrafts";
import PublishedByMe from "../ManagePage/PublishedByMe/PublishedByMe";
import PublishedByOthers from "../ManagePage/PublishedByOthers/PublishedByOthers";
import OrganizePage from "../OrganizePage/OrganizePage";
import PreLoginPage from "../PreLoginPage/PreLoginPage";
import ReportsPage from "../ReportsPage/ReportsPage";
import Announcement from "../SocialPage/Announcement/Announcement";
import ForumArea from "../SocialPage/ForumArea/ForumArea";
import PollManagement from "../SocialPage/PollManagement/PollManagement";
import SocialPage from "../SocialPage/SocialPage";
import MyProfilePage from "../MyProfilePage/MyProfilePage";
import ChangePasswordPage from "../ChangePasswordPage/ChangePasswordPage";
import ContactUsPage from "../ContactUsPage/ContactUsPage";
import UserProfile from "../UserProfile/UserProfile";
import Details from "../ManagePage/CreateShotclasses/Details/Details";
import AddQuiz from "../ManagePage/CreateShotclasses/AddQuiz/AddQuiz";
import AddSurvey from "../ManagePage/CreateShotclasses/AddSurvey/AddSurvey";
import Publish from "../ManagePage/CreateShotclasses/Publish/Publish";
import ShotclassDetails from "../ManagePage/ContentBulkUpload/ShotclassDetails/ShotclassDetails";
import QuestionsAndChoices from "../ManagePage/ContentBulkUpload/QuestionsAndChoices/QuestionsAndChoices";
import QuestionBank from "../ManagePage/ContentBulkUpload/QuestionBank/QuestionBank";
import DailyDigest from "../ManagePage/ContentBulkUpload/DailyDigest/DailyDigest";
import QuizImages from "../ManagePage/ContentBulkUpload/QuizImages/QuizImages";
import GraphicalReport from "../ReportsPage/GraphicalReportPage/GraphicalReportPage";
import AnalyticalReport from "../ReportsPage/AnalyticalReportPage/AnalyticalReportPage";
import AccessReportPage from "../ReportsPage/AccessReportPage/AccessReportPage";
import AdoptionReportPage from "../ReportsPage/AdoptionReportPage/AdoptionReportPage";
import QuizReportPage from "../ReportsPage/QuizReportPage/QuizReportPage";
import TabularReportPage from "../ReportsPage/TabularReportPage/TabularReportPage";
import SurveyReportPage from "../ReportsPage/SurveyReportPage/SurveyReportPage";
import CreatePoll from "../SocialPage/PollManagement/CreatePoll/CreatePoll";
import UserGraphicalReport from "../ReportsPage/GraphicalReportPage/UserGraphicalReportPage/UserGraphicalReport";
import ClassGraphicalReport from "../ReportsPage/GraphicalReportPage/ClassGraphicalReportPage/ClassGraphicalReport";
import UserTabularReport from "../ReportsPage/TabularReportPage/UserTabularReportPage/UserTabularReport";
import ClassTabularReport from "../ReportsPage/TabularReportPage/ClassTabularReportPage/ClassTabularReport";
import ScrollToTop from "./ScrollToTop";
import EventMyDraft from "../EventsPage/EventMyDraft/EventMyDraft";
import EventPublishedByMe from "../EventsPage/EventPublishedByMe/EventPublishedByMe";
import EventPublishedByOthers from "../EventsPage/EventPublishedByOthers/EventPublishedByOthers";
// import EventCreateTrainingType from "../EventsPage/EventCreateTrainingType/EventCreateTrainingType";
import CreateNewEvent from "../EventsPage/CreateNewEvent/CreateNewEvent";
import CreatePasscode from "../EventsPage/CreatePasscode/CreatePasscode";
import EventDetails from "../EventsPage/CreateNewEvent/EventDetails/EventDetails";
import EventAddQuiz from "../EventsPage/CreateNewEvent/EventAddQuiz/EventAddQuiz";
import EventPublish from "../EventsPage/CreateNewEvent/EventPublish/EventPublish";

import PollResult from "../SocialPage/PollManagement/PollResult/PollResult";
import VirtualQuizEvents from "../EventsPage/CreatePasscode/VirtualQuizEvents/VirtualQuizEvents";
import { LiveQuizEvents } from "../EventsPage/CreatePasscode/LiveQuizEvents/LiveQuizEvents";
import TranscribeDetails from "../ManagePage/CreateShotclasses/TranscribeDetails/TranscribeDetails";
import Submissions from "../SocialPage/ModerateContributions/Submissions/Submissions";
import MyModerations from "../SocialPage/ModerateContributions/MyModerations/MyModerations";
import LockByOthers from "../SocialPage/ModerateContributions/LockByOthers/LockByOthers";
import Rejected from "../SocialPage/ModerateContributions/Rejected/Rejected";
import ModerateContributions from "../SocialPage/ModerateContributions/ModerateContributions";
import Published from "../SocialPage/ModerateContributions/Published/Published";
import TabularAdvanceReport from "../ReportsPage/TabularReportPage/TabularAdvanceReportPage/TabularAdvanceReportPage";
import Location from "../AdminPage/OrganizationSettings/Location/Location";
import UserDepartment from "../AdminPage/OrganizationSettings/UserDepartment/UserDepartment";
import SetupUsers from "../AdminPage/OrganizationSettings/SetupUsers/SetupUsers";
import PasswordExpiration from "../AdminPage/OrganizationSettings/PasswordExpiration/PasswordExpiration";
import AddUserForSupport from "../AdminPage/OrganizationSettings/AddUserForSupport/AddUserForSupport";
import OrganizationSettings from "../AdminPage/OrganizationSettings/OrganizationSettings";
import RolesAndPermissions from "../AdminPage/RolesAndPermissions/RolesAndPermissions";
import UserManagementForm from "../AdminPage/UserManagement/UserManagementForm/UserManagementForm";
import AddUserDetails from "../../components/Admin/UserManagement/AddUserDetails/AddUserDetails";
import SelectUserLocation from "../../components/Admin/UserManagement/SelectUserLocation/SelectUserLocation";
import AddAdditionalDetails from "../../components/Admin/UserManagement/AddAdditionalDetails/AddAdditionalDetails";
import GroupManagement from "../AdminPage/GroupManagement/GroupManagement";
import ManageGroup from "../AdminPage/GroupManagement/ManageGroup/ManageGroup";
import AssignUsersToRoles from "../AdminPage/AssignUserToRoles/AssignUsersToRoles";
import EmailTriggers from "../AdminPage/EmailTriggers/EmailTriggers";
import CertificateManagement from "../AdminPage/CertificateManagement/CertificateManagement";
import EngagementCenter from "../AdminPage/EngagementCenter/EngagementCenter";
import NotificationHistory from "../AdminPage/EngagementCenter/NotificationHistory/NotificationHistory";
import DistributeClass from "../DistributePage/DistributeClass/DistributeClass";
import DistributeSeries from "../DistributePage/DistributeSeries/DistributeSeries";
import DistributeCollection from "../DistributePage/DistributeCollection/DistributeCollection";
import MyQueries from "../AdminPage/MyQueries/MyQueries";
import DistributionHistory from "../DistributePage/DistributionHistory/DistributionHistory";
import RecallShotclasses from "../DistributePage/RecallShotclasses/RecallShotclasses";
import NotificationDetails from "../AdminPage/EngagementCenter/NotificationDetails/NotificationDetails";
import DistributeTo from "../DistributePage/DistributeTo/DistributeTo";
import Group from "../DistributePage/DistributeTo/Group/Group";
import PollPage from "../SocialPage/PollManagement/PollPage";
import ReportsMain from "../ReportsPage/ReportsMain";
import AADLoginPage from "../AADLoginPage/AADLoginPage";
import DistributionList from "../DistributePage/DistributeTo/DistributionList/DistributionList";
import Users from "../DistributePage/DistributeTo/Users/Users";
import TopicManagement from "../OrganizePage/TopicManagement/TopicManagement";
import SeriesManagement from "../OrganizePage/SeriesManagement/SeriesManagement";
import CreateGroupTopic from "../OrganizePage/TopicManagement/CreateGroupTopic/CreateGroupTopic";
import CreateNewTopic from "../OrganizePage/TopicManagement/CreateNewTopic/CreateNewTopic";
import GroupTopicDetails from "../OrganizePage/TopicManagement/CreateGroupTopic/GroupTopicDetails/GroupTopicDetails";
import TopicContent from "../OrganizePage/TopicManagement/CreateGroupTopic/TopicContent/TopicContent";
import PublishGroupTopic from "../OrganizePage/TopicManagement/CreateGroupTopic/PublishGroupTopic/PublishGroupTopic";
import NewTopicDetail from "../OrganizePage/TopicManagement/CreateNewTopic/NewTopicDetail/NewTopicDetail";
import NewTopicContent from "../OrganizePage/TopicManagement/CreateNewTopic/NewTopicContent/NewTopicContent";
import PublishNewTopic from "../OrganizePage/TopicManagement/CreateNewTopic/PublishNewTopic/PublishNewTopic";
import CreateNewSeries from "../OrganizePage/SeriesManagement/CreateNewSeries/CreateNewSeries";
import SeriesDetail from "../OrganizePage/SeriesManagement/CreateNewSeries/SeriesDetail/SeriesDetail";
import SeriesContent from "../OrganizePage/SeriesManagement/CreateNewSeries/SeriesContent/SeriesContent";
import PublishSeries from "../OrganizePage/SeriesManagement/CreateNewSeries/PublishSeries/PublishSeries";
import CreateSeries from "../DistributePage/CreateSeries/CreateSeries";
import NotificationSettings from "../DistributePage/CreateSeries/NotificationSettings/NotificationSettings";
import DistributionDetails from "../DistributePage/CreateSeries/DistributionDetails/DistributionDetails";
import CertificateSettings from "../DistributePage/CreateSeries/CertificateSettings/CertificateSettings";
import AccessDeniedPage from "../../components/Common/AccessDenied/AccessDeniedPage";
import SetUpDomainName from "../AdminPage/SetUpDomainName/SetUpDomainName";
import CheckTenantPage from "../CheckTenantPage/CheckTenantPage";
import NoPageFoundPage from "../NoPageFoundPage/NoPageFoundPage";

const RootRoute = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route exact path="/footer" element={<Footer />} />
        {/* <Route exact path="/login" element={<Navigate to={"/"} />} /> */}
        <Route exact path="/" element={<PreLoginPage />} />
        <Route exact path="/prelogin" element={<Navigate to="/" />} />
        <Route exact path="/aadlogin" element={<AADLoginPage />} />
        <Route exact path="/aadlogin/:token" element={<AADLoginPage />} />
        <Route exact path="/checkTenantpage" element={<CheckTenantPage />} />
        <Route exact path="/noPageFound" element={<NoPageFoundPage />} />
        <Route exact path=":tenantName" element={<Outlet />}>
          <Route exact path="login" element={<LoginPage />} />
        </Route>
        <Route exact path=":tenantName" element={<ProtectedRoute />}>
          <Route exact path="/:tenantName" element={<MainPage />}>
            <Route exact path="access-denied" element={<AccessDeniedPage />} />
            <Route exact path="home" element={<DashboardPage />} />
            <Route exact path="manage" element={<ManagePage />}>
              <Route exact path="myDrafts" element={<MyDrafts />} />
              <Route exact path="publishedByMe" element={<PublishedByMe />} />
              <Route
                exact
                path="publishedByOthers"
                element={<PublishedByOthers />}
              />
              <Route
                exact
                path="manageTranscription"
                element={<ManageTranscription />}
              />
              <Route
                exact
                path="createShotclasses"
                element={<CreateShotclasses />}
              >
                <Route exact path="details" element={<Details />} />
                <Route exact path="addQuiz" element={<AddQuiz />} />
                <Route exact path="addSurvey" element={<AddSurvey />} />
                <Route exact path="publishShotclass" element={<Publish />} />
              </Route>
              <Route
                exact
                path="createVariantShotclasses/:shotclassId"
                element={<CreateShotclasses />}
              >
                <Route exact path="details" element={<Details />} />
                <Route exact path="addQuiz" element={<AddQuiz />} />
                <Route exact path="addSurvey" element={<AddSurvey />} />
                <Route exact path="publishShotclass" element={<Publish />} />
              </Route>
              <Route
                exact
                path="editShotclasses/:shotclassId"
                element={<CreateShotclasses />}
              >
                <Route exact path="details" element={<Details />} />
                <Route exact path="addQuiz" element={<AddQuiz />} />
                <Route exact path="addSurvey" element={<AddSurvey />} />
                <Route exact path="publishShotclass" element={<Publish />} />
              </Route>
              <Route
                exact
                path="copyShotclasses/:shotclassId"
                element={<CreateShotclasses />}
              >
                <Route exact path="details" element={<Details />} />
                <Route exact path="addQuiz" element={<AddQuiz />} />
                <Route exact path="addSurvey" element={<AddSurvey />} />
                <Route exact path="publishShotclass" element={<Publish />} />
              </Route>
              <Route
                exact
                path="viewShotclasses/:shotclassId"
                element={<CreateShotclasses />}
              >
                <Route exact path="details" element={<Details />} />
                <Route exact path="addQuiz" element={<AddQuiz />} />
                <Route exact path="addSurvey" element={<AddSurvey />} />
                <Route exact path="publishShotclass" element={<Publish />} />
              </Route>
              <Route
                exact
                path="editTranscribeShotclasses/:shotclassId"
                element={<CreateShotclasses />}
              >
                <Route exact path="details" element={<TranscribeDetails />} />
              </Route>
              <Route
                exact
                path="contentBulkUpload"
                element={<ContentBulkUpload />}
              >
                <Route
                  exact
                  path="shotclassDetails"
                  element={<ShotclassDetails />}
                />
                <Route
                  exact
                  path="questionsAndChoices"
                  element={<QuestionsAndChoices />}
                />
                <Route exact path="questionBank" element={<QuestionBank />} />
                <Route exact path="dailyDigest" element={<DailyDigest />} />
                <Route exact path="quizImages" element={<QuizImages />} />
              </Route>
            </Route>
            <Route exact path="events" element={<EventsPage />}>
              <Route exact path="myDrafts" element={<EventMyDraft />} />
              <Route
                exact
                path="publishedByMe"
                element={<EventPublishedByMe />}
              />
              <Route
                exact
                path="publishedByOthers"
                element={<EventPublishedByOthers />}
              />
              {/* <Route exact path="createTrainingType" element={<EventCreateTrainingType />} /> */}
              <Route exact path="createNewEvent" element={<CreateNewEvent />}>
                <Route exact path="details" element={<EventDetails />} />
                <Route exact path="addQuiz" element={<EventAddQuiz />} />
                <Route exact path="eventPublish" element={<EventPublish />} />
              </Route>
              <Route
                exact
                path="editEventClass/:shotclassId"
                element={<CreateNewEvent />}
              >
                <Route exact path="details" element={<EventDetails />} />
                <Route exact path="addQuiz" element={<EventAddQuiz />} />
                <Route exact path="eventPublish" element={<EventPublish />} />
              </Route>
              <Route
                exact
                path="copyEventClass/:shotclassId"
                element={<CreateNewEvent />}
              >
                <Route exact path="details" element={<EventDetails />} />
                <Route exact path="addQuiz" element={<EventAddQuiz />} />
                <Route exact path="eventPublish" element={<EventPublish />} />
              </Route>
              <Route
                exact
                path="viewEventClass/:shotclassId"
                element={<CreateNewEvent />}
              >
                <Route exact path="details" element={<EventDetails />} />
                <Route exact path="addQuiz" element={<EventAddQuiz />} />
                <Route exact path="eventPublish" element={<EventPublish />} />
              </Route>
              <Route exact path="createPasscode" element={<CreatePasscode />}>
                <Route
                  exact
                  path="virtualQuizEvents"
                  element={<VirtualQuizEvents />}
                />
                <Route
                  exact
                  path="liveQuizEvents"
                  element={<LiveQuizEvents />}
                />
              </Route>
            </Route>
            <Route exact path="distribute" element={<DistributePage />}>
              <Route
                exact
                path="recallShotclasses"
                element={<RecallShotclasses />}
              >
                <Route
                  exact
                  path="recallSelective"
                  element={<RecallShotclasses />}
                />
              </Route>
              <Route
                exact
                path="distributionHistory"
                element={<DistributionHistory />}
              />
              <Route exact path="classes" element={<DistributeClass />} />
              <Route exact path="series" element={<DistributeSeries />} />
              <Route
                exact
                path="collection"
                element={<DistributeCollection />}
              />
              <Route exact path="distributeTo" element={<DistributeTo />}>
                <Route exact path="group" element={<Group />} />
                <Route exact path="users" element={<Users />} />
                <Route
                  exact
                  path="distributionList"
                  element={<DistributionList />}
                />
              </Route>
              <Route exact path="createSeries" element={<CreateSeries />}>
                <Route
                  exact
                  path="notificationSettings"
                  element={<NotificationSettings />}
                />
                <Route
                  exact
                  path="seriesDetails"
                  element={<DistributionDetails />}
                />
                <Route
                  exact
                  path="certificateSettings"
                  element={<CertificateSettings />}
                />
              </Route>
              <Route
                exact
                path="copySeries/:programId"
                element={<CreateSeries />}
              >
                <Route
                  exact
                  path="notificationSettings"
                  element={<NotificationSettings />}
                />
                <Route
                  exact
                  path="seriesDetails"
                  element={<DistributionDetails />}
                />
                <Route
                  exact
                  path="certificateSettings"
                  element={<CertificateSettings />}
                />
              </Route>
              <Route
                exact
                path="editSeries/:programId"
                element={<CreateSeries />}
              >
                <Route
                  exact
                  path="notificationSettings"
                  element={<NotificationSettings />}
                />
                <Route
                  exact
                  path="seriesDetails"
                  element={<DistributionDetails />}
                />
                <Route
                  exact
                  path="certificateSettings"
                  element={<CertificateSettings />}
                />
              </Route>
            </Route>
            <Route exact path="organize" element={<OrganizePage />}>
              <Route exact path="topicManagement" element={<TopicManagement />}>
                <Route
                  exact
                  path="createGroupTopic"
                  element={<CreateGroupTopic />}
                >
                  <Route exact path="details" element={<GroupTopicDetails />} />
                  <Route exact path="topicContent" element={<TopicContent />} />
                  <Route
                    exact
                    path="publishGroupTopic"
                    element={<PublishGroupTopic />}
                  />
                </Route>
                <Route
                  exact
                  path="editGroupTopic/:groupTopicID"
                  element={<CreateGroupTopic />}
                >
                  <Route exact path="details" element={<GroupTopicDetails />} />
                  <Route exact path="topicContent" element={<TopicContent />} />
                  <Route
                    exact
                    path="publishGroupTopic"
                    element={<PublishGroupTopic />}
                  />
                </Route>
                <Route exact path="createNewTopic" element={<CreateNewTopic />}>
                  <Route exact path="details" element={<NewTopicDetail />} />
                  <Route
                    exact
                    path="topicContent"
                    element={<NewTopicContent />}
                  />
                  <Route
                    exact
                    path="publishNewTopic"
                    element={<PublishNewTopic />}
                  />
                </Route>
                <Route
                  exact
                  path="editNewTopic/:topicID"
                  element={<CreateNewTopic />}
                >
                  <Route exact path="details" element={<NewTopicDetail />} />
                  <Route
                    exact
                    path="topicContent"
                    element={<NewTopicContent />}
                  />
                  <Route
                    exact
                    path="publishNewTopic"
                    element={<PublishNewTopic />}
                  />
                </Route>
              </Route>
              <Route
                exact
                path="seriesManagement"
                element={<SeriesManagement />}
              >
                <Route
                  exact
                  path="createNewSeries"
                  element={<CreateNewSeries />}
                >
                  <Route exact path="details" element={<SeriesDetail />} />
                  <Route
                    exact
                    path="seriesContent"
                    element={<SeriesContent />}
                  />
                  <Route
                    exact
                    path="publishSeries"
                    element={<PublishSeries />}
                  />
                </Route>

                <Route
                  exact
                  path="editSeries/:seriesID"
                  element={<CreateNewSeries />}
                >
                  <Route exact path="details" element={<SeriesDetail />} />
                  <Route
                    exact
                    path="seriesContent"
                    element={<SeriesContent />}
                  />
                  <Route
                    exact
                    path="publishSeries"
                    element={<PublishSeries />}
                  />
                </Route>
                <Route
                  exact
                  path="copySeries/:seriesID"
                  element={<CreateNewSeries />}
                >
                  <Route exact path="details" element={<SeriesDetail />} />
                  <Route
                    exact
                    path="seriesContent"
                    element={<SeriesContent />}
                  />
                  <Route
                    exact
                    path="publishSeries"
                    element={<PublishSeries />}
                  />
                </Route>
              </Route>
            </Route>
            <Route exact path="admin" element={<AdminPage />}>
              {/* <Route index element={<AdminPage />} /> */}
              <Route
                exact
                path="organizationSettings"
                element={<OrganizationSettings />}
              >
                <Route exact path="location" element={<Location />} />
                <Route
                  exact
                  path="userDepartment"
                  element={<UserDepartment />}
                />
                <Route exact path="setupUsers" element={<SetupUsers />} />
                <Route
                  exact
                  path="passwordExpiration"
                  element={<PasswordExpiration />}
                />
                <Route
                  exact
                  path="addUserForSupport"
                  element={<AddUserForSupport />}
                />
                <Route
                  exact
                  path="setUpDomainName"
                  element={<SetUpDomainName />}
                />
                <Route
                  exact
                  path="createTrainingType"
                  element={<CreateTrainingType />}
                />
              </Route>
              <Route
                exact
                path="rolesAndPermissions"
                element={<RolesAndPermissions />}
              />
              <Route
                exact
                path="assignUsersToRoles"
                element={<AssignUsersToRoles />}
              />
              <Route exact path="userManagement" element={<UserManagement />}>
                <Route exact path="addUser" element={<UserManagementForm />}>
                  <Route
                    exact
                    path="addUserDetails"
                    element={<AddUserDetails />}
                  />
                  <Route
                    exact
                    path="selectUserLocation"
                    element={<SelectUserLocation />}
                  />
                  <Route
                    exact
                    path="addAdditionalDetails"
                    element={<AddAdditionalDetails />}
                  />
                </Route>
                <Route
                  exact
                  path="editUser/:userId"
                  element={<UserManagementForm />}
                >
                  <Route
                    exact
                    path="addUserDetails"
                    element={<AddUserDetails />}
                  />
                  <Route
                    exact
                    path="selectUserLocation"
                    element={<SelectUserLocation />}
                  />
                  <Route
                    exact
                    path="addAdditionalDetails"
                    element={<AddAdditionalDetails />}
                  />
                </Route>
              </Route>
              <Route exact path="groupManagement" element={<GroupManagement />}>
                <Route
                  exact
                  path="manageUsers/:userGroupId"
                  element={<ManageGroup />}
                />
                <Route
                  exact
                  path="manageSubgroups/:userGroupId"
                  element={<ManageGroup />}
                />
                <Route
                  exact
                  path="manageMandatoryLearnings/:userGroupId"
                  element={<ManageGroup />}
                />
              </Route>
              <Route
                exact
                path="certificateManagement"
                element={<CertificateManagement />}
              />
              <Route exact path="myQueries" element={<MyQueries />} />
              <Route exact path="emailTriggers" element={<EmailTriggers />} />
              <Route exact path="emailTemplates" element={<UserManagement />} />
              <Route
                exact
                path="engagementCenter"
                element={<EngagementCenter />}
              >
                <Route
                  exact
                  path="notificationHistory"
                  element={<NotificationHistory />}
                />
                <Route
                  exact
                  path="addNotification"
                  element={<NotificationDetails />}
                />
                <Route
                  exact
                  path="editNotification/:notificationId"
                  element={<NotificationDetails />}
                />
              </Route>
            </Route>
            <Route exact path="social" element={<SocialPage />}>
              <Route exact path="pollManagement" element={<PollPage />}>
                <Route index element={<PollManagement />} />
                <Route exact path="createPoll" element={<CreatePoll />} />
                <Route
                  exact
                  path="pollResult/:pollId"
                  element={<PollResult />}
                />
              </Route>
              <Route exact path="forumArea" element={<ForumArea />} />
              <Route
                exact
                path="moderateContributions"
                element={<ModerateContributions />}
              >
                <Route exact path="submissions" element={<Submissions />} />
                <Route
                  exact
                  path="updateShotclasses/:shotclassId"
                  element={<CreateShotclasses />}
                >
                  <Route exact path="details" element={<Details />} />
                  <Route exact path="addQuiz" element={<AddQuiz />} />
                  <Route exact path="addSurvey" element={<AddSurvey />} />
                  <Route exact path="publishShotclass" element={<Publish />} />
                </Route>
                <Route
                  exact
                  path="viewShotclasses/:shotclassId"
                  element={<CreateShotclasses />}
                >
                  <Route exact path="details" element={<Details />} />
                  <Route exact path="addQuiz" element={<AddQuiz />} />
                  <Route exact path="addSurvey" element={<AddSurvey />} />
                  <Route exact path="publishShotclass" element={<Publish />} />
                </Route>
                <Route exact path="myModerations" element={<MyModerations />} />
                <Route exact path="lockByOthers" element={<LockByOthers />} />
                <Route exact path="rejected" element={<Rejected />} />
                <Route exact path="published" element={<Published />} />
                <Route
                  exact
                  path="publishedByOthers"
                  element={<PublishedByOthers />}
                />
              </Route>
              <Route exact path="announcement" element={<Announcement />} />
            </Route>
            <Route exact path="reports" element={<ReportsMain />}>
              <Route index element={<ReportsPage />} />
              <Route exact path="graphicalReport" element={<GraphicalReport />}>
                <Route
                  exact
                  path="userGraphicalReport"
                  element={<UserGraphicalReport />}
                />
                <Route
                  exact
                  path="classGraphicalReport"
                  element={<ClassGraphicalReport />}
                />
              </Route>
              <Route
                exact
                path="analyticalReport"
                element={<AnalyticalReport />}
              />
              <Route exact path="accessReport" element={<AccessReportPage />} />
              <Route
                exact
                path="adoptionReport"
                element={<AdoptionReportPage />}
              />
              <Route exact path="quizReport" element={<QuizReportPage />} />
              <Route exact path="tabularReport" element={<TabularReportPage />}>
                <Route
                  exact
                  path="userTabularReport"
                  element={<UserTabularReport />}
                />
                <Route
                  exact
                  path="tabularAdvanceReport"
                  element={<TabularAdvanceReport />}
                />

                <Route
                  exact
                  path="classTabularReport"
                  element={<ClassTabularReport />}
                />
              </Route>
              <Route exact path="surveyReport" element={<SurveyReportPage />} />
            </Route>
            <Route exact path="userProfile" element={<UserProfile />}>
              <Route exact path="myProfile" element={<MyProfilePage />} />
              <Route
                exact
                path="changePassword"
                element={<ChangePasswordPage />}
              />
              <Route exact path="contactUs" element={<ContactUsPage />} />
            </Route>
            <Route path="*" element={<h1>No matching page found</h1>} />
          </Route>
        </Route>
        <Route path="*" element={<h1>No matching page found</h1>} />
      </Routes>
    </Router>
  );
};

export default RootRoute;
